import { Component } from '@angular/core'

@Component({
  selector: 'app-connect-airbnb-warnings',
  templateUrl: './connect-airbnb-warnings.component.html',
})
export class ConnectAirbnbWarningsComponent {}
